"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rollbar = _interopRequireDefault(require("rollbar"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function rollbarInitialize(_ref) {
  var accessToken = _ref.accessToken,
    codeVersion = _ref.codeVersion,
    environment = _ref.environment,
    _ref$isIgnoreError = _ref.isIgnoreError,
    isIgnoreError = _ref$isIgnoreError === void 0 ? false : _ref$isIgnoreError;
  return _rollbar.default.init({
    accessToken: accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    checkIgnore: function checkIgnore(isUncaught, args, payload) {
      // if the request url is not using for sanity check then sending error data to rollbar, else - ignore it
      return payload.request.url.includes('wobi-pr') || isIgnoreError;
    },
    enabled: environment === 'production' || environment === 'development',
    payload: {
      client: {
        javascript: {
          code_version: codeVersion,
          guess_uncaught_frames: true,
          source_map_enabled: true
        }
      },
      environment: environment
    }
  });
}
var _default = exports.default = rollbarInitialize;